import './index.scss'
import Sidebar from '../Sidebar'
import Footer from '../Footer'

const Layout = ({ children }) => {
    return (
    <div className="page-shell">
        <Sidebar />
        <div className="page-content">
            {children}
        </div>
        <Footer />
    </div>
    )
}

export default Layout